module.exports = __webpack_public_path__ + "img/icon-8.f23e91ef.png";